import { render, staticRenderFns } from "./OrganisationsPage.vue?vue&type=template&id=29442178&"
import script from "./OrganisationsPage.vue?vue&type=script&lang=js&"
export * from "./OrganisationsPage.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports